export const FETCH_FAV_PAGE_SUCCESS = 'fetchFavPageSuccess';
export const RESET_FAV_PAGE_M = 'resetFavPageSuccess';
export const FETCH_FAV_PAGE_FAV_LINES_SUCCESS = 'fetchFavPageFavLinesSuccess';
export const ADD_BANNER_PAGE_TO_CLOSED_BANNERS_M = 'ADD_BANNER_PAGE_TO_CLOSED_BANNERS_M';
export const SET_LINES_M = 'SET_LINES_M';
